// The browser tab's title (BUGS.md D192): every page was "Cobrain", so a row of tabs could not be told apart and a
// bookmark or a history entry said nothing of where it led. A page is titled "<page> - Cobrain", by the name the menu
// gives it; a page the menu does not list keeps "Cobrain". A record that names itself (the company record, by its
// company's name) sets its own title over this one while it is open and puts this one back when it closes.
import { useEffect } from 'react';

export const SITE = 'Cobrain';

/** The tab's words for a page's name, or the site's alone when there is none. */
export function documentTitle(name: string | null | undefined): string {
  const n = (name ?? '').trim();
  return n === '' ? SITE : `${n} - ${SITE}`;
}

/** Sets the tab's title for as long as `name` is the one given. */
export function useDocumentTitle(name: string | null | undefined): void {
  useEffect(() => { document.title = documentTitle(name); }, [name]);
}
